module.exports = __webpack_public_path__ + "static/media/CabinetChip_After.b4baf5a1.jpg";